<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperAlternativeLocation',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'alternativeLocationModule',
    };
  },
};
</script>
